const actions = {
  SET_STATE: 'meetings/SET_STATE',
  SEND_MEETING: 'meetings/SEND_MEETING',
  GET_MEETING: 'meetings/GET_MEETING',
  ACCEPT_REQUEST: 'meetings/ACCEPT_REQUEST',
  REJECT_REQUEST: 'meetings/REJECT_REQUEST',
}

export default actions
